export function parseVersion(version: string): [number, number, number] {
    const [major = 0, minor = 0, patch = 0] = version.split(".").map(part => Number.parseInt(part, 10));
    return [Number.isFinite(major) ? major : 0, Number.isFinite(minor) ? minor : 0, Number.isFinite(patch) ? patch : 0];
}

export function isNewerVersion(latest: string, current: string): boolean {
    const [lMajor, lMinor, lPatch] = parseVersion(latest);
    const [cMajor, cMinor, cPatch] = parseVersion(current);

    if (lMajor !== cMajor) {
        return lMajor > cMajor;
    }
    if (lMinor !== cMinor) {
        return lMinor > cMinor;
    }
    return lPatch > cPatch;
}

export function buildReloadUrl(origin: string, version?: string | null): string {
    const params = new URLSearchParams();
    params.set("_", Date.now().toString());
    if (version) {
        params.set("v", version);
    }
    return `${origin}/index.html?${params.toString()}`;
}
